module.exports = __webpack_public_path__ + "static/img/-8_119.c0bf8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue8/-8_119.jpg
// module id = X2W3
// module chunks = 7